import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {createAlchemyWeb3} from '@alch/alchemy-web3';
import { initializeApp } from 'firebase/app';


async function initialize() {
  const web3 = createAlchemyWeb3("wss://eth-mainnet.alchemyapi.io/v2/Ugq4Pcd3ZiOhZESQVC_UcGPy0OGJt3Yi");
  const firebaseConfig = {
    apiKey: "AIzaSyCq6HNx5cn27N0YGz4uNcCenu5_DOewANg",
    authDomain: "thisisarugnft.firebaseapp.com",
    projectId: "thisisarugnft",
    storageBucket: "thisisarugnft.appspot.com",
    messagingSenderId: "155899961166",
    appId: "1:155899961166:web:b7dfd89b138716265c081f"
  };
  const app = initializeApp(firebaseConfig);
  return {
      app, web3
  };
}

initialize().then((props) => {
  ReactDOM.render(
    <App {...props}/>,
  document.getElementById('root')
);
var Particles = require('particlesjs');
window.onload = function() {
  Particles.init({
    selector: '.background',
    color: '#808080',
    maxParticles: 200,
    connectParticles: true,
  });
};
})
